import { Menu, MenuItem } from '@mui/material';
import React from 'react';
export function RowMenu({ el, row, rowMenuItems, onClose }) {
    if (el && row) {
        return (React.createElement(Menu, { anchorEl: el, anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, transformOrigin: { horizontal: 'right', vertical: 'top' }, open: true, onClose: onClose }, rowMenuItems.map((rowMenuItem) => (React.createElement(MenuItem, { key: rowMenuItem.label, onClick: () => {
                onClose();
                rowMenuItem.onClick(row);
            } }, rowMenuItem.label)))));
    }
    else {
        return null;
    }
}
